import { render, staticRenderFns } from "./productHistory.vue?vue&type=template&id=010591c6&scoped=true"
import script from "./productHistory.vue?vue&type=script&lang=js"
export * from "./productHistory.vue?vue&type=script&lang=js"
import style0 from "./productHistory.vue?vue&type=style&index=0&id=010591c6&prod&scoped=true&lang=scss"
import style1 from "./productHistory.vue?vue&type=style&index=1&id=010591c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010591c6",
  null
  
)

export default component.exports